window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.casinoBonusPobjedniciRepo = function () {

    var url = 'api/casinobonuspobjednici';

    var list = function (bonusSifra, nadimak, najveciBrojSpinovaID, podebljajNajveciDobitakID, aktivno) {


        return fetch(url + casino.repos.base.serializeGetParams({
                sifra: bonusSifra,
                nadimak: nadimak || '',
                najveciBrojSpinova: najveciBrojSpinovaID || null,
                podebljajNajveciDobitak: podebljajNajveciDobitakID || null,
                aktivno: aktivno
            }), {
                credentials: repos.base.credentials
            })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);

    };

    return {
        list: list
    }

}();